function ReportSettingsModalController(accountService, toasterService, eventService, userService) {
  const ctrl = this;
  ctrl.updatable = true;
  const getReportTypes = async () => {
    try {
      return await accountService.getReportType();
    } catch (e) {
      return `Error fetching report types: ${e}`;
    }
  };
  const getUserReportSetting = async (id) => {
    try {
      return await accountService.getUserReportSetting(id);
    } catch (e) {
      return `Error fetching report settings: ${e}`;
    }
  };

  ctrl.$onInit = async () => {
    ctrl.account = angular.copy(ctrl.resolve.account);

    ctrl.reportTypes = (await getReportTypes()).reduce(function(obj, v) {
      obj[v] = false;
      return obj;
    }, {});
    ctrl.userReportSetting = await getUserReportSetting(ctrl.account.id);
    for (let key in ctrl.reportTypes) {
      const reportType = key;
      const x = ctrl.userReportSetting.findIndex((obj) => obj.reportType === reportType);
      if (x > -1) {
        ctrl.reportTypes[key] = true;
      }
    }
    ctrl.originalSetting = angular.copy(ctrl.reportTypes);
  };

  ctrl.update = () => {
    Promise.all([
      userService.changeReportSettings({ userId: ctrl.account.id, reports: ctrl.reportTypes }),
    ]).then(
      function() {
        toasterService.success('toaster.edit-account', 'toaster.edit-account-successful');
        eventService.trigger('accounts.update');
        ctrl.close();
      },
      function() {
        toasterService.error('toaster.edit-account', 'toaster.edit-account-failure');
      },
    );
  };

  ctrl.updateChange = () => {
    ctrl.updatable = _.isEqual(ctrl.originalSetting, ctrl.reportTypes);
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('users.module')
  .controller('ReportSettingsModalController', ReportSettingsModalController);
